
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post109() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Oi gente. Vai fazer dois meses que fiz a última quimioterapia da branca de cinco horas cada foram seis seções e estou ainda totalmente dormente nos pés e dor nas pernas e cólicas. Já fiz três braquiterapia e agora vou fazer 24 radioterapias. Mas essa dormência é terrível.</title>
        <meta 
          name="description" 
          content="Oi gente. Vai fazer dois meses que fiz a última quimioterapia da branca de cinco horas cada foram seis seções e estou ainda totalmente dormente nos pés e dor nas pernas e cólicas. Já fiz três braquiterapia e agora vou fazer 24 radioterapias. Mas essa dormência é terrível."/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Mariana Zandona &#183; 16/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Oi gente. Vai fazer dois meses que fiz a última quimioterapia da branca de cinco horas cada foram seis seções e estou ainda totalmente dormente nos pés e dor nas pernas e cólicas. Já fiz três braquiterapia e agora vou fazer 24 radioterapias. Mas essa dormência é terrível.
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/109')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  5 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Oi, Mariana! Boa tarde!<br/><br/>Sinto muito saber que você está passando por isso. A dormência nos pés, as dores nas pernas e as cólicas podem realmente ser muito desconfortáveis, especialmente após um tratamento tão intenso como a quimioterapia. Esses são efeitos colaterais comuns, mas isso não faz com que sejam mais fáceis de suportar, né?<br/><br/>Você já conversou com seu médico sobre esses sintomas? Eles podem fornecer dicas específicas sobre como lidar com a dormência e a dor, e talvez ajustar seu tratamento para aliviar esses efeitos. Enquanto isso, alguns pacientes encontram um pouco de alívio com medidas simples, como:<br/><br/>- Manter os pés elevados quando estiver sentada.<br/>- Fazer movimentos suaves, como alongamentos leves, pode ajudar com a circulação sanguínea.<br/>- Usar sapatos confortáveis e meias podem minimizar o desconforto nos pés.<br/><br/>Para as cólicas, manter-se hidratada e tentar pequenas refeições para não sobrecarregar o estômago pode ajudar um pouco. Mas o mais importante é realmente discutir isso com seu médico, porque ele pode ter soluções mais específicas e apropriadas para o seu caso.<br/><br/>Se precisar de mais alguma coisa ou tiver outras dúvidas, estou aqui para ajudar. Você é uma guerreira e está indo muito bem, continue firme!<br/><br/>Abraços,<br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 16/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/109')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Marli Seccon &#183; 10/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/65-colesterol" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal, queria uma opinião. A médica me disse que meu colesterol tá alto e me passou sinvastatina. Meus resultados estão o seguinte: Ldl 131, Colesterol total 218, Triglicerídeos 65, Hdl 71. Oque vcs acham?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/65')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    T. Estudante &#183; 24/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/11-diabetes" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Diabetes: Minha experiência medindo glicose em casa  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Após o diagnóstico com diabetes, a melhor coisa que fiz foi comprar um medidor de glicose, aprender a usar e medir todos os dias. Recomendo para todos sempre. Acredito que esse seja o melhor jeito para aprender a controlar a diabetes.<br/><br/>Dica: para mim, o melhor lugar para espetar o dedo é nos lados das pontas, perto das unhas (mas não muito perto).<br/><br/>Teste sua glicose com a maior frequência que você conseguir: Isso é especialmente importante no início, quando você está aprendendo como seu corpo reage às diferentes comidas e os exercícios físicos que você faz.<br/><br/>A maioria das pessoas gosta de medir quando levantam de manhã. Isso é chamado de teste de jejum, e dá uma indicação de quão bom foi o seu controle no dia anterior.<br/><br/>Outros horários comuns para testar:<br/><br/>1) Uma ou duas horas depois de uma refeição: o resultado mostra quão alto a sua glicose sobre quando você come aquelas comidas em particular. Toda a comida que você põe na boca influencia o nível de glicose, e é importante entender como é essa influência.<br/><br/>2) Antes da próxima refeição: o resultado mostra se a subida da glicose da refeição anterior já desceu para o patamar normal antes da próxima refeição.<br/><br/>3) Antes e depois de exercício.<br/><br/>4) Na hora de dormir.<br/><br/>5) A qualquer momento que você acha que tem algo de errado.<br/><br/>É legal rotacionar os horários de teste ao longo dos dias para conseguir mais informações.<br/><br/>Após mais ou menos um ano com esse treinamento intensivo, eu tinha um bom conhecimento de como meu corpo reagia as várias coisas, e pude reduzir a frequência das medições.<br/><br/>Por fim, registre e guarde os resultados das medições (no caderno, no computador ou no excel, onde você quiser), e também tenha cópia de todos os seus exames. Ter esses registros vai fazer com que você estude mais para entendê-los e vai te ajudar a saber como está a sua condição ao longo do tempo. No longo prazo, esse registros valem ouro!<br/><br/>Espero que isso possa ajudar quem está começando sua jornada com diabetes!<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/11')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Mariana Zandona &#183; 24/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/150-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi gente. Depois que comecei a tomar glifage meu cabelo começou a cair muito, sera que é o medicamento?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/150')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Marlene Techini &#183; 07/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/35-pressao" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal<br/>Alguém trocou propranolol por metoprolol?<br/>Tem alguma diferença significativa?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/35')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Danna Rosa &#183; 16/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/108-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Bom dia pessoal. Tenho diabetes, e quero tirar uma dúvida. <br/>Esse negócio de tomar uma colherzinha de vinagre antes do almoço, é verdade ou ilusão?<br/>Percebo que no pós fica baixa a glicemia, mas fico em dúvida se em algum momento que não estou controlando, da pico.
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/108')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            5 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
